import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/workspace/apps/frontend/src/context/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/apps/frontend/src/providers/QueryProvider.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/workspace/apps/frontend/src/styles.css");
